export const convertToSpan = (cols, width) => {
    let [dividend, divisor] = width ? width.split('/') : ['1', '1'];
    divisor = divisor || 1;
    return (dividend * cols) / divisor;
};
